import { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container, Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane
} from "reactstrap";

import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

//Simple bar

import BreadCrumb from "../../Components/Common/BreadCrumb";

import classnames from "classnames";
import { useSelector } from "react-redux";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { axiosIns } from "../../utils";
import { isLegacyCrmEnabled } from "../../constants/featureFlags";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

  
SwiperCore.use([FreeMode, Navigation, Thumbs]);


function OpportunitesDetails(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const {categories } = useSelector((state) => ({
    categories :state.Ecommerce.categories
  
  }));
  const opportunitesId = useParams('id');

  const [selectContact, setSelectContact] = useState([])
  const [selectCollaborateur, setSelectCollaborateur] = useState([])
  useEffect(() => {
      const fetchData = async () => {
        try {
          if (!isLegacyCrmEnabled) return;
          const data  = await axiosIns.get(`/contacts`);
          setSelectContact(data?.data || data || [])
        } catch (err) {
          console.error(err);

        }
      };
      fetchData();

    }, []);

  useEffect(() => {
      const fetchData = async () => {
        try {
          if (!isLegacyCrmEnabled) return;
          const data  = await axiosIns.get(`/collaborateurs`);
          setSelectCollaborateur(data?.data || data || [])
        } catch (err) {
          console.error(err);

        }
      };
      fetchData();

    }, []);
  const [selectOpportunites, setSelectOpportunites] = useState([
    {
      "type": null,
      "title": "",
      "value": null,
      "date": null,
      "description": "",
      "owner": null,
      "contact": null,
    }
  ])
 
  useEffect(() => {
      const fetchData = async () => {
        try {
          if (!isLegacyCrmEnabled) return;
          const data  = await axiosIns.get(`/opportunities/${opportunitesId.id}/`);
          setSelectOpportunites(data?.data || data || {})
        } catch (err) {
          console.error(err);

        }
      };
      fetchData();

    }, [opportunitesId]);

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const contact=(j)=>{
  for(let i=1; i <= selectContact.length;i++){
     if(j=== selectContact[i].id){
       return selectContact[i].nom
     }
    }
  }

  const collaborateur=(j)=>{
    for(let i=1; i<=selectCollaborateur.length;i++){
       if(j=== selectCollaborateur[i].id){
          return selectCollaborateur[i].nom
       }
       else return ""
      }
    }


document.title =props.t("Détail de l'opportunité");
  return (
    <div className="page-content">
      <Container fluid>        
        {!isLegacyCrmEnabled && (
          <div className="alert alert-warning">
            {props.t(
              "Le module opportunites n'est pas encore disponible sur le nouveau backend."
            )}
          </div>
        )}
        <BreadCrumb title={props.t("Détail de l'opportunité")} pageTitle={props.t("Opportunités")} />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={12}>
                    <div className="mt-xl-0 mt-5">
                     
                      <div className="product-content mt-2">
                        <h5 className="fs-14 mb-3">{props.t("Informations de l'opportunité")}</h5>
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                             { props.t("Opportunité")}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "2",
                              })}
                              onClick={() => {
                                toggleCustom("2");
                              }}
                            >
                              {props.t("Détails de l'opportunité")}
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent
                        activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane
                            id="nav-speci"
                            tabId="1"
                          >
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row" style={{ width: "200px" }}>
                                      {props.t("Libellé")}
                                    </th>
                                    <td> {selectOpportunites.title}</td>
                                  </tr>
                                  <br></br>
                                  <tr>
                                  
                                    <th scope="row"> {props.t("Date ")} </th>
                                    <td>{selectOpportunites.date}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                          <TabPane
                            id="nav-detail"
                            tabId="2"
                          >
                             <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                <tr>
                                    <th scope="row"> {props.t("Responsable")} </th>
                                    <td>{collaborateur(selectOpportunites.owner)}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {props.t("Contact")} </th>
                                    <td>{contact(selectOpportunites.contact)}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {props.t("description")} </th>
                                    <td>{selectOpportunites.description}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                           
                          </TabPane>
                        </TabContent>
                      </div>

                      
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

OpportunitesDetails.propTypes={
  location:PropTypes.object,
  t:PropTypes.any
}
export default withRouter(withTranslation()(OpportunitesDetails));